import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ContactModal } from './ContactModal';
export function Navigation() {
  const location = useLocation();
  const [isContactOpen, setIsContactOpen] = useState(false);
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white px-8 py-4" data-id="element-381">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-382">
          <Link to="/" onClick={handleScrollToTop} className="text-2xl" data-id="element-383">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kjxpxqyEwcLcsAF3CAEe64/Fight_Club_Med_Spa_logo_%28500_x_250_px%29.png" alt="Fight Club Med Spa" className="h-14 w-auto" data-id="element-384" />
          </Link>
          <div className="flex gap-8 font-body text-sm tracking-widest uppercase" data-id="element-385">
            <Link to="/services" onClick={handleScrollToTop} className={`relative py-2 hover:opacity-70 transition-opacity ${location.pathname === '/services' ? 'text-black after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-[rgba(250,179,212,0.5)]' : 'text-gray-600'}`} data-id="element-386">
              <span className="md:hidden" data-id="element-387">SERVICES</span>
              <span className="hidden md:inline" data-id="element-388">PRICING & SERVICES</span>
            </Link>
            <button onClick={() => setIsContactOpen(true)} className="relative py-2 text-gray-600 hover:opacity-70 transition-opacity" data-id="element-389">
              CONTACT
            </button>
          </div>
        </div>
      </nav>
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} data-id="element-390" />
    </>;
}